var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.288 5.304a1.03 1.03 0 0 0 0 1.459L13.525 12l-5.237 5.237a1.031 1.031 0 1 0 1.458 1.458l5.967-5.966a1.03 1.03 0 0 0 0-1.458L9.746 5.304a1.03 1.03 0 0 0-1.458 0"
  })));
};
export default SvgChevronRight;